import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '../../utils';
export function WithEndDecorator({ endDecorator, emptyEndDecorator, decoratorComponent, startDecorator, emptyStartDecorator, alignItems = 'baseline', ...props }) {
    if (endDecorator ||
        emptyEndDecorator ||
        startDecorator ||
        emptyStartDecorator) {
        return (_jsxs(WithEndDecoratorStyled, { ...props, alignItems: alignItems, children: [(startDecorator || emptyStartDecorator) && (_jsx(EndDecoratorStyled, { children: startDecorator })), decoratorComponent, (endDecorator || emptyEndDecorator) && (_jsx(EndDecoratorStyled, { children: endDecorator }))] }));
    }
    return decoratorComponent;
}
const WithEndDecoratorStyled = styled('div', {
    shouldForwardProp: (prop) => prop !== 'alignItems' && prop !== 'justifyContent',
})(({ theme, alignItems, justifyContent }) => ({
    display: 'flex',
    alignItems,
    justifyContent,
    gap: theme.spacing(1.5),
}));
const EndDecoratorStyled = styled('div')(({ theme }) => ({
    minWidth: theme.spacing(4),
    display: 'grid',
    placeItems: 'center',
}));
